const PropTypes = require('prop-types');
const React = require('react');
const PriceDisplay = require('components/shared/price_display.jsx');
const ReactDOMServer = require('react-dom/server');


// Similar to PriceDisplay, used to show 'Free Shipping' or '$10 Shipping'.
// Does not render a currency code since it's meant to be used next to the
// main price (which can have a currency code).
// Expects a Entities::Money object
class ShippingPrice extends React.Component {
  isFree() {
    return this.price.amount_cents === 0;
  }

  get price() {
    return this.props.shippingRate;
  }

  render() {
    if (!this.props.shippingRate) { return false; }
    if (this.isFree()) { return <span>{I18n.t('js.listing.shipping.free')}</span>; }

    const price = <PriceDisplay price={this.price} showCurrency={false} />;
    const translation = I18n.t('js.listing.shipping.price', {
      price: ReactDOMServer.renderToString(price),
    });
    return (
      <span dangerouslySetInnerHTML={{ __html: translation }} />
    );
  }
}

ShippingPrice.propTypes = {
  shippingRate: PropTypes.object,
};


module.exports = ShippingPrice;



// WEBPACK FOOTER //
// ./javascripts/components/listings/shipping_price.jsx